<arm-layout [summaryTitle]="'NETWORK SUMMARY'">
    <div header>
        <div class="search-container">
            <arm-search [searchComponent]="mapSearchComponent"
                        [searchData]="searchData"
                        [searchTerms]="searchTerms"
                        [localSearch]="true"
                        (onSearch)="onSearch($event)">
            </arm-search>
        </div>

        <div class="action-buttons">

            <arm-action-bar (editClick)="editItem()" (refreshClick)="refreshMap()" (deleteClick)="deleteItem()"
                            [disableDelete]="!isAuthorized || isDeleteItemDisabled()"
                            [disableEdit]="!isSingleSelection() || isConnectionsCluster()">
            </arm-action-bar>

            <button [matMenuTriggerFor]="menu" class="more-actions" color="primary" mat-raised-button>
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button (click)="syncTopology()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Sync Topology</span>
                </button>
                <button (click)="addConnection()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Add connection</span>
                </button>
                <button (click)="dragConnectionMode()" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Drag Connection</span>
                </button>
                <button (click)="testRoute()" [disabled]="isAnyElementsOnMap() || isTestRouteDisabled" mat-menu-item>
                    <span>Test Route</span>
                </button>
                <button [matMenuTriggerFor]="lockUnlock" [disabled]="!isAuthorized" mat-menu-item>
                    <span>Lock\Unlock</span>
                </button>
            </mat-menu>

            <mat-menu #lockUnlock="matMenu">
                <button (click)="lockItem()" [disabled]="isLockDisabled()" mat-menu-item>
                    <span>Lock</span>
                </button>
                <button (click)="lockPConsForIncoming()" *ngIf="isOnlyPConsSelected()"
                        [disabled]="selectedItemAdminState() === 'LOCKED_INCOMING'" mat-menu-item>
                    <span>Lock Incoming</span>
                </button>
                <button (click)="lockPConsForOutgoing()" *ngIf="isOnlyPConsSelected()"
                        [disabled]="selectedItemAdminState() === 'LOCKED_OUTGOING'" mat-menu-item>
                    <span>Lock Outgoing</span>
                </button>
                <button (click)="unlockItem()" [disabled]="isUnlockDisabled()" mat-menu-item>
                    <span>Unlock</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div summary>
        <map-summary-container [diagramSelection]="diagramSelection"></map-summary-container>
    </div>

    <div main>
        <map-diagram [(diagramApi)]="diagramApi" (diagramItemAdded)="diagramItemAdded($event)"
                     (edgeDragged)="createConnection($event)" (onDiagramSelect)="onDiagramSelect($event)"
                     class="drop-shadow-gray-border main-view-panel height-adjustment"></map-diagram>
    </div>
</arm-layout>
